import {useEffect, useState} from 'react';
import styles from './style.module.css';
import BarChart from './BarChart';
import Lineage from './Lineage';
import {useRecoilState} from "recoil";
import {selectedModelState, namespaceState} from "../../../recoil/atoms";
import useApi from '../../../services/useApi';
import isBaseModel from "../../../utils/isBaseModel";
import RoundMetric from './RoundMetric';

export default function ModelChart({className, model, isLineage, onLineageChange}) {
    const [nsState, setNsState] = useRecoilState(namespaceState);
    const userId = JSON.parse(localStorage.getItem("account")).id;
    const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);

    const [isTab,setIsTab]=useState('accuracy');
    const [isBarHover,setIsBarHover]=useState(null);
    const [hoverTimeout,setHoverTimeout]=useState(null);
    const [bestData,setBestData]=useState(null);
    const [lineageData, setLineageData]=useState({});
    const [isInitModel,setIsInitModel]=useState(false);

    useEffect(()=>{
        if(selectedModel?.task?.roundNum===0){
            setIsInitModel(true)
        }else{
            setIsInitModel(false)
        }
    },[selectedModel])

    useEffect(() => {
        useApi.get('/ngp/modelreg/mm/model/v1/lineage?modelId='+selectedModel.modelId+'&namespaceId='+nsState.id+'&userId='+userId+'&pageSize='+50+'&includeDetail='+true)
        .then((res) => {
          setLineageData(res.data)
          if(res.data&&res.data.items&&res.data.items.length > 0) {
              onLineageChange(res.data.items[0].detail.snapshot);
          } else {
            onLineageChange({});
          }
        })
        .catch(err=>{
        })
    }, [selectedModel])

    useEffect(()=>{
        if(!selectedModel)return;
        useApi.get('/ngp/modelreg/mm/model/v1/model/task/top?modelId='+selectedModel.modelId+'&namespaceId='+nsState.id+'&userId='+userId+'&orderBy='+ (isTab==='loss'?'training/loss&direction=asc':'evaluation/accuracy&direction=desc'))
        .then((res) => {
            const newData=res.data.tasks.map((item,index)=>({
                index:index,
                taskId:item.taskId,
                taskName:item.taskName,
                roundNum:item.roundNum,
                modelId:item.modelId,
                accuracy:item.evaluationResult.accuracy??item.evaluationResult.mae,
                loss:item.trainingResult.loss,
            }))
            setBestData(newData);
        })
    },[isTab])

    const handleBarHover=(nowBarHover)=>{
        if(hoverTimeout){
            clearTimeout(hoverTimeout)
        }
        const timeoutId=setTimeout(() => {
            setIsBarHover(nowBarHover);
        }, 1200);
        setHoverTimeout(timeoutId);
    }

    const handleBarLeave=()=>{
        if(hoverTimeout){
            clearTimeout(hoverTimeout);
        }
        setIsBarHover(null);
    }

    const isTestRound = () => {
        if(selectedModel.task&&selectedModel.task.testResult) {
            return true;
        } return false;
    }

    return (
        <div className={`${className} ${styles['wrap']}`}>
            <div className={styles['header']}>
                <div className={`${styles['header-title']} 
                ${!isLineage?styles['header-chart']:styles['header-lineage']}`}>
                    {!isLineage? (isBaseModel(selectedModel) ? "Best Evaluation" : "Round Metric") :"Lineage"}
                </div>
                {!isLineage && !isTestRound() && isBaseModel(selectedModel) &&
                    <div className={styles['header-tab']}>
                        <button
                            className={`${isTab === 'loss'
                            && styles['tab-on']}`}
                            onClick={() => setIsTab('loss')}>Loss
                        </button>
                        <button
                            className={`${isTab === 'accuracy'
                            && styles['tab-on']}`}
                            onClick={() => setIsTab('accuracy')}>Accuracy
                        </button>
                    </div>
                }
            </div>
            {!isInitModel
            ?<div className={`${styles['chart']} ${isLineage
            && styles['chart-lineage']}`}>
                {!isLineage ?
                    (isBaseModel(selectedModel) ?
                        bestData&&<BarChart
                            data={bestData}
                            sortBy={isTab}
                            onHover={handleBarHover}
                            onLeave={handleBarLeave}
                            nowBarHover={isBarHover}
                        />:
                        <RoundMetric/>
                    ):
                    <Lineage
                        data={lineageData}
                        onLineageChange={onLineageChange}
                    />
                }
            </div>
            :<span>Initial Model does not have performance.</span>
            }
        </div>
    )
}